import {
  INotificationConfig,
  NotififcationPresets,
  SystemNotifiactionIcon,
} from '@/ui/molecules/SystemNotifications/notifications.type'
import style from './style.module.scss'
import { Trans } from '@lingui/react'
import clsx from 'clsx'
import { TLanguage } from '@/core/constants'
import { t } from '@lingui/macro'

interface IСashbackTigerXAlert {
  isMobile: boolean
  language: TLanguage
}

export function getCashbackTigerXAlert({ isMobile, language }: IСashbackTigerXAlert): INotificationConfig {
  const now = new Date().getTime()
  const endDate = new Date('2025-04-23')
  endDate.setHours(23, 59, 59, 999)

  const uri =
    language === 'en'
      ? 'https://broker-docs.tiger.com/english-2/tigerx'
      : 'https://broker-docs.tiger.com/interfeis/tigerx'

  const preset: INotificationConfig = {
    id: NotififcationPresets.TigerXBetaTest,
    icon: SystemNotifiactionIcon.Alert,
    heading: (
      <span className={clsx(isMobile && style.mobile, style.label)}>
        <Trans id="core.systemAlert.tigerXBeta.label" />
      </span>
    ),
    description: (
      <Trans
        id="core.systemAlert.tigerXBeta.description"
        components={{
          link: (
            <a
              className={style.link}
              href="https://account.tiger.com/voucher"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t({
                id: 'core.systemAlert.tigerXBeta.linkDescription',
              })}
            </a>
          ),
          colored: <span className={style.colored}></span>,
        }}
      />
    ),
    shouldShown: false,
    availableExchange: ['TIGER_X', 'BINANCE_BROKER_FUTURE', 'OKX_AFFILIATE'],
    isClosable: true,
    link: {
      uri,
      external: true,
    },
  }

  return preset
}
